import axios from 'axios';
import moment from 'moment';

const apikey = 'AIzaSyCygWsx1gjrfztrNwmC7kzyyDYhqWCv46o';
const playlistId = 'PL2VOF042nR3Gd8QuMZS8gKXjEEV5ms2j1';
const endpoint = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${playlistId}&key=${apikey}&maxResults=48`;

export class Youtube {
  constructor () {
    this.episodes = [];
  }

  load = () => new Promise((resolve, reject) => {
    var _endpoint = endpoint;
    
    if (this.nextPageToken) _endpoint += `&pageToken=${this.nextPageToken}`;
    
    axios.get(_endpoint).then(response => {
      console.log(response.data)
      this.nextPageToken = response.data.nextPageToken;
      this.episodes.push(...this.parse(response.data.items))
      resolve(this.episodes);
    }).catch(reject);
  });

  parse = (items) => items.map(item => ({
    url: 'https://www.youtube.com/watch?v=' + item.snippet.resourceId.videoId,
    image: item.snippet.thumbnails.high.url,
    date: moment(item.snippet.publishedAt),
    title: item.snippet.title,
    youtubeId: item.snippet.resourceId.videoId,
    tags: []
  }));
}
